import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddMedida({ onNewUnidad, editingUnidad }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [unidad, setUnidad] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState(1);
    const [IngresadoPor, setIngresadoPor] = useState('');

    // Función para obtener la fecha actual en formato ISO sin la 'Z' final
    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        const fechaISO = fecha.toISOString().slice(0, -1);
        return fechaISO;
    }
    const fechaFormateada = obtenerFechaISOsinZ();
    // Efecto para cargar la información de la medida si estamos en modo de edición
    useEffect(() => {
        if (editingUnidad) {
            setUnidad(editingUnidad.descripcionUnidadDeMedida);
            setIngresadoPor(editingUnidad.ingresadoPor);

        }
    }, [editingUnidad]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Crear el objeto de medida a enviar
        const medida = {
            idUnidadDeMedida: editingUnidad ? editingUnidad.idUnidadDeMedida : 0,  // Si estamos editando, usamos el ID existente
            descripcionUnidadDeMedida:unidad,
            IngresadoPor: !editingUnidad ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
            ModificadoPor: editingUnidad ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
        
        };
        Object.keys(medida).forEach(key => medida[key] === undefined && delete medida[key]);

        // Determinar el método HTTP y el endpoint dependiendo de si estamos agregando o editando
        const method = editingUnidad ? 'PUT' : 'POST';
        const endpoint = editingUnidad ? `${server}/MgUnidadesDeMedidums/${editingUnidad.idUnidadDeMedida}` : `${server}/MgUnidadesDeMedidums`;

        try {
            const response = await fetch(endpoint, {
                method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(medida),
            });

            if (response.ok) {
                // Limpiar el formulario después de la operación exitosa
                setUnidad('');
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });    
                            onNewUnidad(); // Llamar al método para recargar las medidas en el componente padre
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });            }
        } catch (error) {
          
            Swal.fire({
                icon: 'error',
                title: 'Error al agregar o editar la medida',
                text: error || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>{editingUnidad ? "Editar Medida" : "Agregar Medida"}</h2>
            <br />
            <form className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="unidad">
                        Unidad: <span className="required">*</span>
                    </label>
                    <div className="col-md-3 col-sm-6">
                        <input
                            type="text"
                            id="unidad"
                            required
                            className="form-control"
                            value={unidad}
                            onChange={(e) => setUnidad(e.target.value)}
                        />
                    </div>
                </div>
                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Unidad Medida')}>Guardar</button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddMedida;
